export const getHeaderHeight = () => {
    const header = document.querySelector("#nav");
    const headerHeight = header ? header.offsetHeight : 0;
    return headerHeight;
};
